(() => {
  "use strict";
  const doc = document, root = doc.documentElement;
  const ITA = (window.ITA = window.ITA || {});

  /* event bus */
  ITA.on = (e, fn) => doc.addEventListener("ita:" + e, fn);
  ITA.off = (e, fn) => doc.removeEventListener("ita:" + e, fn);
  ITA.emit = (e, detail) => doc.dispatchEvent(new CustomEvent("ita:" + e, { detail }));

  /* section modules, lazy */
  const mods = {}, done = new WeakMap();
  const io = "IntersectionObserver" in window ? new IntersectionObserver((es) => {
    es.forEach((x) => { if (x.isIntersecting) { io.unobserve(x.target); run(x.target); } });
  }, { rootMargin: "400px 0px" }) : null;
  function run(el) {
    if (done.has(el)) return;
    const fn = mods[el.dataset.ita]; if (!fn) return;
    let clean = null;
    try { clean = fn(el) || null; } catch (err) { console.error("[ita]", el.dataset.ita, err); }
    done.set(el, clean);
  }
  function scan(scope) {
    (scope || doc).querySelectorAll("[data-ita]").forEach((el) => {
      if (done.has(el) || !mods[el.dataset.ita]) return;
      if (!io || el.hasAttribute("data-ita-eager")) run(el); else io.observe(el);
    });
  }
  ITA.define = (name, init) => { mods[name] = init; scan(); };
  doc.addEventListener("shopify:section:load", (e) => scan(e.target));
  doc.addEventListener("shopify:section:unload", (e) => {
    e.target.querySelectorAll("[data-ita]").forEach((el) => { const c = done.get(el); if (typeof c === "function") c(); done.delete(el); });
  });

  /* cart */
  const R = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
  /* theme preview (draft): a plain fetch is 301ed to the live domain and fails, so keep the preview session (_fd=0&_sc=1) on every cart call; live theme: no change */
  const SH = window.Shopify && Shopify.theme, PV = SH && SH.role && SH.role !== "main" ? "_fd=0&_sc=1" : "", pu = (url) => PV ? url + (url.indexOf("?") > -1 ? "&" : "?") + PV : url;
  const j = (url, body) => fetch(R + pu(url), body ? { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify(body) } : { headers: { Accept: "application/json" } })
    .then((r) => r.json().then((d) => { if (!r.ok) throw d; return d; }));
  const fresh = (p) => p.then(() => j("cart.js")).then((cart) => { ITA.emit("cart:updated", { cart }); return cart; });
  ITA.cart = {
    get: () => j("cart.js"),
    add: (items) => fresh(j("cart/add.js", { items: Array.isArray(items) ? items : [items] })),
    change: (key, quantity) => fresh(j("cart/change.js", { id: key, quantity })),
    update: (updates) => fresh(j("cart/update.js", { updates })),
    note: (note) => fresh(j("cart/update.js", { note })),
  };

  /* money. ITA_MONEY_SAMPLE = Shopify's own rendering of 12,345.67 in the shopper's currency and market format (set by layout/theme.liquid),
     so JS prices use the same symbol, separators and decimals as the Liquid prices on the page (EUR 48,95 and 12.345,67; JPY 12,346; no guessing).
     Fallback: ITA_MONEY, the shop money format string. */
  const sampleFmt = (S) => {
    const m = S && S.match(/\d[\d.,  ’' ]*\d/); if (!m) return null;
    const num = m[0], pre = S.slice(0, m.index), suf = S.slice(m.index + num.length);
    const d2 = num.match(/^(.*?)([.,])(\d{2})$/), dec = d2 && d2[3] === "67" ? 2 : 0, dsep = dec ? d2[2] : "";
    const ip = dec ? d2[1] : num, tm = ip.match(/[^\d]/), tsep = tm ? tm[0] : "";
    return (cents) => {
      const n = (cents || 0) / 100, a = Math.abs(n), s = dec ? a.toFixed(2) : String(Math.round(a)), neg = n < 0 && +s !== 0; /* no "-$0.00" / "-¥0" when the amount rounds to zero */
      const parts = s.split("."), ipart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, tsep);
      return (neg ? "-" : "") + pre + ipart + (dec ? dsep + parts[1] : "") + suf;
    };
  };
  let sampleMoney = null;
  ITA.money = (cents) => {
    if (sampleMoney === null) sampleMoney = sampleFmt(window.ITA_MONEY_SAMPLE) || false;
    if (sampleMoney) return sampleMoney(cents);
    const f = window.ITA_MONEY || "${{amount}}", n = (cents || 0) / 100;
    const fix = (d, s, t) => n.toFixed(d).replace(/\B(?=(\d{3})+(?!\d))/g, t).replace(/\.(\d+)$/, s + "$1");
    return f.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => k === "amount_no_decimals" ? fix(0, ".", ",") : k === "amount_with_comma_separator" ? fix(2, ",", ".") : k === "amount_no_decimals_with_comma_separator" ? fix(0, ",", ".") : fix(2, ".", ","));
  };

  /* drawers + scrim */
  let scrim = null, last = null;
  const open = new Set();
  function sc() { if (!scrim) { scrim = doc.createElement("div"); scrim.className = "scrim"; scrim.addEventListener("click", () => [...open].forEach(close)); doc.body.appendChild(scrim); } return scrim; }
  function show(id) {
    const d = doc.getElementById(id); if (!d) return;
    last = doc.activeElement; d.classList.add("on"); d.removeAttribute("hidden"); open.add(id);
    sc().classList.add("on"); root.classList.add("ita-lock");
    const f = d.querySelector("[autofocus],input,button,a[href]"); if (f) setTimeout(() => f.focus({ preventScroll: true }), 30);
    ITA.emit("drawer:open", { id });
  }
  function close(id) {
    const d = doc.getElementById(id); if (!d || !open.has(id)) return;
    d.classList.remove("on"); open.delete(id);
    if (!open.size) { sc().classList.remove("on"); root.classList.remove("ita-lock"); if (last && last.focus) last.focus({ preventScroll: true }); }
    ITA.emit("drawer:close", { id });
  }
  ITA.drawer = { open: show, close, toggle: (id) => (open.has(id) ? close(id) : show(id)), isOpen: (id) => open.has(id) };
  doc.addEventListener("click", (e) => {
    const o = e.target.closest("[data-open]");
    if (o) { e.preventDefault(); const id = o.dataset.open; [...open].forEach((x) => x !== id && close(x)); ITA.drawer.toggle(id); return; }
    const c = e.target.closest("[data-close]");
    if (c) { const d = c.closest(".drawer,[role=dialog]"); if (d && d.id) { e.preventDefault(); close(d.id); } }
  });
  doc.addEventListener("keydown", (e) => { if (e.key === "Escape" && open.size) [...open].forEach(close); });

  /* toast */
  ITA.toast = (msg, ms) => { const t = doc.getElementById("ita-toast"); if (!t) return; t.textContent = msg; t.classList.add("on"); clearTimeout(t._t); t._t = setTimeout(() => t.classList.remove("on"), ms || 2400); };

  doc.addEventListener("pointermove", (e) => { root.classList.toggle("ita-mouse", e.pointerType === "mouse"); }, { passive: true });

  (function () {
    const GIF = /\.gif(\?|$)/i;
    function still(img) {
      if (img.dataset.still || img.hasAttribute("data-gif")) return;
      const src = img.currentSrc || img.src || ""; if (!GIF.test(src)) return;
      img.dataset.still = "1";
      const t = new Image(); t.crossOrigin = "anonymous";
      t.onload = () => { try { const c = doc.createElement("canvas"); c.width = t.naturalWidth; c.height = t.naturalHeight; c.getContext("2d").drawImage(t, 0, 0); const u = c.toDataURL("image/jpeg", 0.9); img.removeAttribute("srcset"); img.removeAttribute("sizes"); img.src = u; } catch (e) {} };
      t.src = src;
    }
    function scanGif(scope) { (scope || doc).querySelectorAll("img").forEach((i) => { if (i.complete || i.currentSrc) still(i); else i.addEventListener("load", () => still(i), { once: true }); }); }
    const run = () => { scanGif(); new MutationObserver((ms) => ms.forEach((m) => m.addedNodes.forEach((n) => { if (n.nodeType !== 1) return; if (n.tagName === "IMG") { if (n.complete) still(n); else n.addEventListener("load", () => still(n), { once: true }); } else scanGif(n); }))).observe(doc.body, { childList: true, subtree: true }); };
    if (doc.readyState === "loading") doc.addEventListener("DOMContentLoaded", run); else run();
    doc.addEventListener("load", (e) => { if (e.target && e.target.tagName === "IMG") still(e.target); }, true);
  })();

  /* product card reveal (snippets/ita-card): mouse hover = .rev; touch = the small reveal button toggles it (mid.js cardEvents) */
  /* hover photos load + decode before the mouse gets there, so the swap is instant (no half loaded or soft frame) */
  if (matchMedia("(hover:hover) and (pointer:fine)").matches && "IntersectionObserver" in window) {
    const warm = new IntersectionObserver((es) => es.forEach((en) => { if (!en.isIntersecting) return; warm.unobserve(en.target); en.target.querySelectorAll(".m-tile img").forEach((im) => { im.loading = "eager"; if (im.decode) im.decode().catch(() => {}); }); }), { rootMargin: "400px 0px" });
    const scan = () => doc.querySelectorAll(".m-card.can-rev:not([data-warm])").forEach((c) => { c.dataset.warm = "1"; warm.observe(c); });
    let sq = 0; scan(); new MutationObserver(() => { if (!sq) sq = requestAnimationFrame(() => { sq = 0; scan(); }); }).observe(doc.body, { childList: true, subtree: true });
  }
  doc.addEventListener("pointerover", (e) => { if (e.pointerType !== "mouse") return; const c = e.target.closest(".m-card.can-rev"); if (c && !c.contains(e.relatedTarget)) c.classList.add("rev"); });
  doc.addEventListener("pointerout", (e) => { if (e.pointerType !== "mouse") return; const c = e.target.closest(".m-card.can-rev"); if (c && !c.contains(e.relatedTarget)) c.classList.remove("rev"); });
  doc.addEventListener("click", (e) => {
    const b = e.target.closest(".m-rv"); if (!b) return; e.preventDefault(); e.stopPropagation();
    const c = b.closest(".m-card"), on = !c.classList.contains("rev");
    doc.querySelectorAll(".m-card.rev").forEach((x) => { x.classList.remove("rev"); const xb = x.querySelector(".m-rv"); if (xb) xb.setAttribute("aria-pressed", "false"); });
    c.classList.toggle("rev", on); b.setAttribute("aria-pressed", String(on));
  }, true);


  const CTA = [["f", ".co-coll"], ["m", "#nav,#menuD,#sx"], ["p", "[data-ita='pdp']"], ["s", "[data-ct-area='s']"], ["q", "[data-ct-area='q'],[data-ita='co-lc']"], ["fo", ".foot"], ["c", "#cartD,.co-cart"]];
  const ctLum = (c) => { const m = String(c).match(/[\d.]+/g); if (!m || m.length < 3) return 1; if (m.length > 3 && +m[3] === 0) return null; return (0.2126 * m[0] + 0.7152 * m[1] + 0.0722 * m[2]) / 255; };
  const ctBg = (el) => { for (let e = el; e && e.nodeType === 1; e = e.parentElement) { const l = ctLum(getComputedStyle(e).backgroundColor); if (l !== null) return l; } return 1; };
  let ctT = 0;
  function ctScan() {
    CTA.forEach(([k, sel]) => {
      if (!root.classList.contains("ct-" + k)) return;
      doc.querySelectorAll(sel).forEach((r) => r.querySelectorAll("*").forEach((e) => {
        if (e.dataset.ct || /^(SCRIPT|STYLE|SVG|PATH|IMG|INPUT|TEXTAREA|SELECT)$/i.test(e.tagName)) return;
        if (e.closest(".stb,.cs,.rt,.igg,.bfN5,.bfp,.bfk")) return;
        let has = false; for (const n of e.childNodes) { if (n.nodeType === 3 && n.nodeValue.trim()) { has = true; break; } } if (!has) return;
        const cs = getComputedStyle(e); if (!/Space Mono|monospace/i.test(cs.fontFamily)) return;
        e.dataset.ct = k; e.style.setProperty("--ctf", Math.min(15.5, Math.max(13, Math.round((parseFloat(cs.fontSize) || 11) + 2))) + "px");
        const tl = ctLum(cs.color); if (tl !== null && tl < 0.6 && ctBg(e) > 0.6) e.dataset.ctd = "1";
      }));
    });
  }
  if ([...root.classList].some((c) => c.startsWith("ct-"))) {
    const go = () => { clearTimeout(ctT); ctT = setTimeout(ctScan, 120); };
    const startCt = () => { ctScan(); new MutationObserver(go).observe(doc.body, { childList: true, subtree: true }); };
    if (doc.readyState === "loading") doc.addEventListener("DOMContentLoaded", startCt); else startCt();
    if (doc.fonts && doc.fonts.ready) doc.fonts.ready.then(go);
  }
  if (doc.readyState === "loading") doc.addEventListener("DOMContentLoaded", () => scan()); else scan();
})();
(function () {
  /* Lazy photos are warmed just before they scroll into view, so no tile ever shows unloaded, but ONLY those: the earlier pass
     (2026-10-29) flipped every lazy photo on the page to eager right after load, which on the home page meant ~270 photos / 6 MB
     (closed menus and the footer included) downloading on every visit and made the whole site feel slow on phones. */
  var SEL = 'img[loading="lazy"]';
  function eager(im) { im.loading = 'eager'; if (im.decoding !== 'sync') im.decoding = 'async'; }
  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (es) { for (var i = 0; i < es.length; i++) { if (es[i].isIntersecting) { io.unobserve(es[i].target); eager(es[i].target); } } }, { rootMargin: '1200px 0px' }) : null;
  if (!io) return; /* no observer: the browser's own lazy loading stands */
  function warm(scope) { var q = (scope || document).querySelectorAll(SEL); for (var i = 0; i < q.length; i++) { var im = q[i]; if (im.__itaW) continue; im.__itaW = 1; io.observe(im); } }
  var pend = 0; function queue() { if (!pend) pend = setTimeout(function () { pend = 0; warm(); }, 150); }
  function start() { warm(); new MutationObserver(queue).observe(document.body, { childList: true, subtree: true }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
  document.addEventListener('shopify:section:load', queue);
})();
(function () { if (!document.fonts || !document.fonts.forEach) return; function loadAll() { try { document.fonts.forEach(function (f) { if (f.status === 'unloaded') f.load().catch(function () {}); }); } catch (e) {} }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', loadAll); else loadAll(); })();
